import { Box, Grid, Typography } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import useAPI from "../../../../api/hooks/useAPI";
import useIsIntegrated from "../../../../api/hooks/useIsIntegrated";
import SecondaryButton from "../../../../components/buttons/SecondaryButton";
import useExpandedList from "../../../../components/hooks/ExpandedList";
import { logos } from "../../environment/icons/iconExport";
import Guideline from "../components/Guideline";
import GuidelineInstruction from "../components/GuidelineInstruction";
import GuidelineStep from "../components/GuidelineStep";
import GuidelineStepByStep from "../components/GuidelineStepByStep";
import IntegrationGuideAlert from "../components/IntegrationGuideAlert";

function Notion() {
  const { isIntegrated } = useIsIntegrated("notion");
  const [authUrl, setAuthUrl] = useState("");
  const [searchParams] = useSearchParams();
  const [guideMode, setGuideMode] = useState(false);
  const { handleExpandAll, handleCollapseAll } = useExpandedList();

  const { fetchNotionAuthUrl } = useAPI();

  useEffect(() => {
    if (searchParams.has("viewonly")) {
      setGuideMode(true);
    }
  }, [searchParams]);

  useEffect(() => {
    if (authUrl === "") {
      fetchNotionAuthUrl().then((response) => {
        setAuthUrl(response.data.url);
      });
    }
  }, []);

  const showSetupGuide = guideMode || !isIntegrated;

  return (
    <Box sx={{ width: "100%" }}>
      <Guideline
        title={
          !isIntegrated
            ? "Once integrated, Breeze Security will connect to your Notion workspace."
            : ""
        }
        image={logos.NotionLogo}
        name={"Notion"}
        content={
          isIntegrated && !showSetupGuide ? (
            <Fragment>
              <Typography variant={"h4"} sx={{ mb: 3 }}>
                Notion is integrated!
              </Typography>
            </Fragment>
          ) : (
            <>
              <Box sx={{ marginBottom: 2 }}>
                {guideMode && <IntegrationGuideAlert />}
              </Box>
              <Box mb="20px">
                <Grid container spacing={2} direction={"row"}>
                  <Grid item>
                    <SecondaryButton onClick={handleExpandAll}>
                      Expand All Screenshots
                    </SecondaryButton>
                  </Grid>
                  <Grid item>
                    <SecondaryButton onClick={handleCollapseAll}>
                      Collapse All Screenshots
                    </SecondaryButton>
                  </Grid>
                </Grid>
              </Box>
              <GuidelineStepByStep>
                <GuidelineStep title={"Connect to Notion"}>
                  <Typography
                    variant={"subtitle1"}
                    display={"flex"}
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"baseline"}
                  >
                    {"Visit the "}
                    <SecondaryButton
                      onClick={() => {
                        window.location.href = authUrl;
                      }}
                    >
                      authorization page
                    </SecondaryButton>
                    {" for Notion."}
                  </Typography>
                </GuidelineStep>

                <GuidelineStep title={"Authorization Steps"}>
                  <GuidelineInstruction text="You will be redirected to Notion where you can authorize Breeze Security to access your workspace." />
                  <GuidelineInstruction text="After authorization, the Notion server will communicate with our backend and you will be redirected back to this page with the integration automatically set up." />
                </GuidelineStep>
              </GuidelineStepByStep>
            </>
          )
        }
        subTitle={undefined}
        subContent={undefined}
      />
    </Box>
  );
}

export default Notion;
